/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPowerPlugDiagIcon24Solid = forwardRef('TechPowerPlugDiagIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M17.834.863a1.5 1.5 0 0 1 0 2.121L14.12 6.697l3.182 3.182 3.713-3.712a1.5 1.5 0 1 1 2.121 2.121L19.425 12l.884.884a1.75 1.75 0 0 1 0 2.475l-1.945 1.944A8.253 8.253 0 0 1 8.066 18.41L3.16 23.314a1.75 1.75 0 0 1-2.475-2.475l4.905-4.905A8.253 8.253 0 0 1 6.697 5.636L8.64 3.691a1.75 1.75 0 0 1 2.475 0l.884.884L15.712.863a1.5 1.5 0 0 1 2.122 0Z" })));
});
